<template>
  <div class="row_start_start order_item_list">
    <div class="column_start_around" style="flex-grow: 1;">
      <div class="row_center_between" style="width: 100%;">
        <text class="title" style="font-size: 18px;">{{ product.product.name }}</text>
        <div class="row_center_center">
          <text class="text-black text-xl font-semibold">x{{ product.quantity }}</text>
        </div>
      </div>
      <div class="row_center_start w-full flex-wrap my-1" v-if="product.isCombo && customizedText.length">
        <text>{{ displayComboSpecOptionText }}</text>
      </div>
      <div class="row_center_start w-full flex-wrap my-1" v-else-if="!product.isCombo && customizedText.length">
        <text>{{ displayProductSpecOptionText }}</text>
      </div>
      <div class="row_center_start w-full flex-wrap" v-if="note">
        <text>備註：{{ note }}</text>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    note() {
      return this.product.note
    },
    displayProductSpecOptionText() {
      return this.$store.getters['cart/displayProductSpecOptionText'](this.customizedText);
    },
    displayComboSpecOptionText() {
      return this.$store.getters['cart/displayComboSpecOptionText'](this.customizedText);
    },
    customizedText() {
      return this.$store.getters['cart/customizedText'](this.product);
    }
    // customizedText() {
    //   const specOptions = [];

    //   // 給一般餐點使用
    //   const productSpecSettings = (setting) => {
    //     const productOption = {
    //       title: '',
    //       specOptions: [],
    //     };

    //     if (setting.subSpecOptionSelectCount && setting.specOptions && setting.specOptions.length === setting.subSpecOptionSelectCount.length) {
    //       const specCount = setting.subSpecOptionSelectCount?.reduce((acc, count) => acc + count, 0) || 0;
    //       if (specCount !== 0) {
    //         const specOption = {
    //           title: setting.frontEndDisplayName,
    //           options: setting.subSpecOptionSelectCount.map((count, index) => {
    //             if (count !== 0) {
    //               const specName = setting.specOptions[index].name;
    //               const specPrice = setting.specOptions[index].price;
    //               if (specPrice && specPrice > 0) return `${specName} +${specPrice}`;
    //               else if (specPrice && specPrice < 0) return `${specName} ${specPrice}`;
    //               return specName;
    //             }
    //             return null;
    //           }).filter(Boolean), // 過濾掉 null 值
    //         };
    //         productOption.specOptions.push(specOption);
    //       }
    //     }

    //     return productOption;
    //   }

    //   // 給套餐使用
    //   const comboSpecSettings = (comboSub) => {
    //     const productOption = {
    //       title: comboSub.name || '',
    //       specOptions: [],
    //       altAddonPrice: comboSub.altAddonPrice || 0
    //     };

    //     if (comboSub.productSpecSettings && comboSub.productSpecSettings.length) {
    //       comboSub.productSpecSettings.forEach((spec) => {
    //         const specCount = spec.subSpecOptionSelectCount?.reduce((acc, count) => acc + count, 0) || 0;
    //         if (specCount !== 0) {
    //           const specOption = {
    //             title: spec.frontEndDisplayName,
    //             options: spec.subSpecOptionSelectCount.map((count, index) => {
    //               if (count !== 0) {
    //                 const specName = spec.specOptions[index].name;
    //                 const specPrice = spec.specOptions[index].price;
    //                 if (specPrice && specPrice > 0) return `${specName} +${specPrice}`;
    //                 else if (specPrice && specPrice < 0) return `${specName} ${specPrice}`;
    //                 return specName;
    //               }
    //               return null;
    //             }).filter(Boolean), // 過濾掉 null 值
    //           };
    //           productOption.specOptions.push(specOption);
    //         }
    //       });
    //     }

    //     return productOption;
    //   };

    //   const processProducts = (products, productCounts) => {
    //     products.forEach((product, index) => {
    //       if (productCounts[index] !== 0) {
    //         specOptions.push(comboSpecSettings(product));
    //       }
    //     });
    //   };

    //   if (this.product.isCombo) {
    //     // 套餐 - 固定餐點
    //     if (this.product.fixedProducts?.length) {
    //       this.product.fixedProducts.forEach(product => {
    //         specOptions.push(comboSpecSettings(product));
    //       });
    //     }

    //     // 套餐子項任選
    //     if (this.product.comboSubItem?.length) {
    //       this.product.comboSubItem.forEach((products) => {
    //         processProducts(products.products.concat(products.markUpProducts || []), products.productSelectCount);
    //       });
    //     }

    //     // 任選子項
    //     if (this.product.comboSubAnyProducts?.orderProducts?.length) {
    //       processProducts(this.product.comboSubAnyProducts.orderProducts, this.product.comboSubAnyProducts.orderProducts.map(() => 1));
    //     }
    //   } else {
    //     // 一般餐點
    //     if (this.product.settings?.length) {
    //       this.product.settings.forEach((setting) => {
    //         const productOption = productSpecSettings(setting);
    //         if (productOption.specOptions.length) {
    //           specOptions.push(productOption);
    //         }
    //       });
    //     }
    //   }

    //   return specOptions;
    // }
  },
};
</script>
<style lang="scss" scoped>
.order_item_list {
  width: 100%;
  font-size: 14px;
  color: #666666;
  background-color: #fff;
  border: none;


  .options {
    width: 100%;
    flex-grow: 1;
    margin-top: 10px;
  }
}
</style>
